import {types} from './types';

const setGetListFreespinAction = (payload) => {
    return {
        type: types.SET_LIST_FREESPIN,
        payload,
      }
}


export {
  setGetListFreespinAction
}
